/**
 * Canonical validators & helpers for person-shaped form fields (name, email,
 * phone). Single source of truth — see
 * DOCUMENTATION/02-DEVELOPMENT/ui-components/UI-CONSISTENCY-STANDARDS.md.
 *
 * Before this module, the app had three different email-validation approaches
 * and per-form phone regexes. Use these everywhere a person's email/phone is
 * captured; do NOT introduce new patterns.
 */

import { ValidatorFn, Validators } from '@angular/forms';

/**
 * Permissive international phone format: optional leading +, then 8-20 chars
 * of digits / spaces / dashes / dots / parentheses (covers Belgian dotted
 * notation like 02.534.12.34 and grouped formats like +32 2 123 45 67).
 */
export const PHONE_PATTERN = /^[+]?[0-9\s\-().]{8,20}$/;

/** Phone format validator (empty values pass — combine with Validators.required if needed). */
export const phoneValidator: ValidatorFn = Validators.pattern(PHONE_PATTERN);

/** Canonical email validator — always Angular's, never a custom regex. */
export const emailValidator: ValidatorFn = Validators.email;

/** Join first/last name into a display name, tolerating either being empty. */
export function fullName(firstName?: string | null, lastName?: string | null): string {
  return [firstName, lastName]
    .map((part) => (part ?? '').trim())
    .filter(Boolean)
    .join(' ');
}
